import { axiosInstance } from '../Config/axios';

const API_URL = `v1/faqs/`;

// Función para listar todas las FAQs (GET)
export const getFaqs = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las FAQs:', error);
    throw error;
  }
};